<template >
  <div class="container-fluid">
    <div class="card  shadow mb-4" v-if="content!=null">
      <div class='card-body'>
        <div class="row">
          <div class="col">
            <h2 class="h2">{{content.name}}</h2>
          </div>
          <div class="col-auto">
            <div class="pr-5">
              <h4>
                <span style="cursor:pointer; background-color:#1cc88a;" 
                  @click="_setPublishedContent(false)"
                  v-if="content.published==true"
                  class="badge badge-pill badge-danger">нээлттэй</span>

                <span style="cursor:pointer"
                  @click="_setPublishedContent(true)"
                  v-else
                  class="badge badge-pill badge-secondary"
                >xаагдсан</span>
              </h4>
            </div>
          </div>
        </div>
        <p>Та асуулгыг нээлттэй болгосоноор оюутнууд хариулах боломжтой болно.</p>
      </div>
    </div>

    <hr class="my-5"/>
    <div class="row justify-content-between p-3">
      <div class="col-8">
        <h3 class="h3">Асуултууд</h3>
      </div>
      <div class="col-md-auto" v-if="categories==null || (categories!=null && categories.length==0)">
        <button class="btn btn-primary" @click="_addCategory">Бүлэг нэмэx</button>
      </div>
      <!-- <div class="col-md-auto">
        <button class="btn btn-primary" @click="addQuestion('new')">Асуулт нэмэх</button>
      </div> -->
      
    </div>


    <div v-if="categories!=null && categories.length>0">
      <div v-for="(cat, index) in categories" v-bind:key="cat.id">
          <div class="row justify-content-between">
            <div class="col-10"><h3 class="m-0 font-weight-bold text-primary" style="font-size:14pt">{{index+1}}. {{cat.name}}</h3> </div>
            <div class="col col-md-auto"><i class="fas fa-trash" style="cursor:pointer" @click="deleteCategory(cat)"></i></div>
            <div class="col col-md-auto"><i
                class="fas fa-edit pr-5"
                @click="editCategory(cat)"
                style="cursor:pointer"
                data-toggle="Засаx"
                data-placement="bottom"
                title="Засаx"
              ></i>
            </div>
            
          </div>
          <div class="row my-3">
            <div class="col-md-auto">
              <button class="btn btn-success btn-sm" @click="addQuestion(cat.id, true)">Энгийн асуулт нэмэх</button>
            </div>
            <div class="col-md-auto">
              <button class="btn btn-danger btn-sm" @click="addQuestion(cat.id, false)">Дэд асуулттай асуулт нэмэх</button>
            </div>
          </div>
          <hr/>
          <div v-if="cat.questions!=null && cat.questions.length>0">
            <div class="card shadow mb-4" v-for="(que, index) in cat.questions" v-bind:key="que.id">
              <div class="card-header py-3">
                <div class="row justify-content-between">
                  <div class="col col-10">
                    <h5 class="m-0 font-weight-bold text-primary" style="font-size:12pt">{{index+1}}. {{que.title}}/{{que.category}}</h5>
                  </div>
                  <!-- <div class="col col-md-auto">
                    <i class="fas fa-trash" style="cursor:pointer" @click="deleteQuestion(que)"></i>
                  </div> -->
                  <div class="col col-md-auto">
                    <i class="fas fa-edit mr-3" style="cursor:pointer" @click="editQuestion(que, cat)"></i>
                    <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lessonId+'/topics/'+ topicId+'/details/'+detailId+'/tests/'+cat.id+'/questions/'+que.id}}">Зураг</router-link>
                  </div>
                  
                </div>
                <div class="row  text-center text-lg-left" v-if="que.images!=null && que.images.length>0">
                    <div class="col-lg-3 col-md-4 col-6" v-for="(file, index) in que.images" v-bind:key="file.fileUrl">
                        <a href="#" class="d-block mb-4 h-100">
                        <img class="img-fluid img-thumbnail" :src="file.fileUrl" @click="deleteFile(file, index)"/>
                        </a>
                    </div>
                </div>
                <br/>
                <p>{{que.description}}</p>
                <div class="row justify-content-md-center">
                  <div class="pr-5">
                    <h4>
                      <span style="cursor:pointer; background-color:#1cc88a;" 
                        @click="_setLabel(que.id, false, 'public', cat)"
                        v-if="que.public==true"
                        class="badge badge-pill badge-danger"
                      >нээлттэй</span>
                      <span style="cursor:pointer"
                        @click="_setLabel(que.id, true, 'public', cat)"
                        v-else
                        class="badge badge-pill badge-secondary"
                      >xаагдсан</span>
                    </h4>
                  </div>
            
                </div>

                <div class="card mb-4" v-for="(subquestion, index) in que.subquestions" v-bind:key="subquestion.id">
                  <div class="card-header py-3">
                    <h4>{{subquestion.title}}</h4>
                    <div v-if="subquestion.answertype==true">
                      <div class="panel panel-primary" id="result_panel" v-if="subquestion.useranswers!=null && subquestion.useranswers.length>0">
                        <div class="panel-heading"><h6 class="panel-title">Хариултууд</h6>
                        </div>
                        <div class="panel-body">
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(answer, index) in subquestion.useranswers" v-if="answer!=null && answer.answer!=null && answer.answer!='Хариулт байхгүй'">
                                  <strong>{{index+1}}.</strong> {{answer.answer}}
                                </li>
                            </ul>
                        </div>
                      </div>
                      
                    </div>

                    <div v-else>
                      <div class="row" v-if="subquestion.answers!=null && subquestion.answers.length>0">
                        <div class="col-lg-6 mb-4">
                          <h6>Хариултууд</h6>
                          <ul class="list-group">
                            <li
                              v-for="(answer, index) in subquestion.answers"
                              v-bind:key="answer.id"
                              class="list-group-item"
                            >
                              <div class="row">
                                <div class="col col-10"><span class="font-weight-bold">{{index+1}}. &nbsp;</span> {{answer.name}}</div>
                                <div class="col col-2">
                                  <span v-if="answer.correct" class="badge badge-success badge-pill">зөв</span>
                                  <span v-else class="badge badge-danger badge-pill">буруу</span>
                                  &nbsp;&nbsp;
                                  <span class="badge badge-primary badge-pill">{{answer.votedCount}}</span>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div class="col-lg-6 mb-4">
                          <div class="post" v-if="subquestion.statData!=null && subquestion.datacollection">
                            <bar-chart :chartData="subquestion.datacollection" :options="options"></bar-chart>

                            <!-- <apexcharts  type="bar" :options="statData.chartOptions" :series="statData.series"></apexcharts> -->
                          </div>
                          <div v-else class="alert alert-success">Одоогоор энэ асуултанд хүн хариулаагүй байна.</div>
                        </div>
                      </div>

                      <div v-else class="alert alert-success">Одоогоор энэ асуултанд хариулт оруулаагүй байна.</div>
                    </div>
                  </div>

                </div>

                

              </div>
            </div>
          </div>
      </div>
    </div> 
    <div v-if="questions!=null && questions.length>0">
      <div class="card shadow mb-4" v-for="(question, index) in questions" v-bind:key="question.id">
        <div class="card-header py-3">
          <div class="row justify-content-between">
            <div class="col col-10">
              <h3 class="m-0 font-weight-bold text-primary" style="font-size:12pt">{{index+1}}. {{question.title}}</h3>
            </div>
            <div class="col col-md-auto">
              <i class="fas fa-edit" style="cursor:pointer" @click="editQuestion(question, null)"></i>
              <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lessonId+'/topics/'+ topicId+'/details/'+detailId+'/questions/'+question.id}}">Зураг</router-link>
            </div>
          </div>
          <div class="row  text-center text-lg-left" v-if="question.images!=null && question.images.length>0">
              <div class="col-lg-3 col-md-4 col-6" v-for="(file, index) in question.images" v-bind:key="file.fileUrl">
                  <a href="#" class="d-block mb-4 h-100">
                  <img class="img-fluid img-thumbnail" :src="file.fileUrl" @click="deleteFile(file, index)"/>
                  </a>
              </div>
          </div>
          <br/>
          <p>{{question.description}}</p>
          <div class="row justify-content-md-center">
            <div class="pr-5">
              <h4>
                <span style="cursor:pointer; background-color:#1cc88a;" 
                  @click="_setLabel(question.id, false, 'public', null)"
                  v-if="question.public==true"
                  class="badge badge-pill badge-danger"
                >нээлттэй</span>
                <span style="cursor:pointer"
                  @click="_setLabel(question.id, true, 'public', null)"
                  v-else
                  class="badge badge-pill badge-secondary"
                >xаагдсан</span>
              </h4>
            </div>
            <div class="pr-5">
              <h4>
                <span style="cursor:pointer" 
                  @click="_setLabel(question.id, true, 'closed', null)"
                  v-if="question.closed!=true"
                  class="badge badge-pill badge-danger"
                >open</span>
                <span
                  @click="_setLabel(question.id, false, 'closed', null)"
                  v-else
                  class="badge badge-pill badge-secondary"
                >closed</span>
              </h4>
            </div>
            <div class="pr-5">
              <h4>
                <span
                  @click="_setLabel(question.id, true, 'showResult', null)"
                  v-if="question.showResult!=true"
                  class="badge badge-pill badge-danger"
                >hidden</span>
                <span
                  @click="_setLabel(question.id, false, 'showResult', null)"
                  v-else
                  class="badge badge-pill badge-secondary"
                >shown</span>
              </h4>
            </div>
          </div>

          <div class="card mb-4" v-for="(subquestion, index) in question.subquestions" v-bind:key="subquestion.id">
            <div class="card-header py-3">
              <h4>{{subquestion.title}}</h4>
              <div v-if="subquestion.answertype==true">
                <div class="panel panel-primary" id="result_panel" v-if="subquestion.useranswers!=null && subquestion.useranswers.length>0">
                  <div class="panel-heading"><h6 class="panel-title">Хариултууд</h6>
                  </div>
                  <div class="panel-body">
                      <ul class="list-group">
                          <li class="list-group-item" v-for="(answer, index) in subquestion.useranswers" v-if="answer!=null && answer.answer!=null && answer.answer!='Хариулт байхгүй'">
                            <strong>{{index+1}}.</strong> {{answer.answer}}
                          </li>
                      </ul>
                  </div>
                </div>
                
              </div>

              <div v-else>
                <div class="row" v-if="subquestion.answers!=null && subquestion.answers.length>0">
                  <div class="col-lg-6 mb-4">
                    <h6>Хариултууд</h6>
                    <ul class="list-group">
                      <li
                        v-for="(answer, index) in subquestion.answers"
                        v-bind:key="answer.id"
                        class="list-group-item"
                      >
                        <div class="row">
                          <div class="col col-10"><span class="font-weight-bold">{{index+1}}. &nbsp;</span> {{answer.name}}</div>
                          <div class="col col-2">
                            <span v-if="answer.correct" class="badge badge-success badge-pill">зөв</span>
                            <span v-else class="badge badge-danger badge-pill">буруу</span>
                            &nbsp;&nbsp;
                            <span class="badge badge-primary badge-pill">{{answer.votedCount}}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="col-lg-6 mb-4">
                    <div class="post" v-if="subquestion.statData!=null && subquestion.datacollection">
                      <bar-chart :chartData="subquestion.datacollection" :options="options"></bar-chart>

                      <!-- <apexcharts  type="bar" :options="statData.chartOptions" :series="statData.series"></apexcharts> -->
                    </div>
                    <div v-else class="alert alert-success">Одоогоор энэ асуултанд хүн хариулаагүй байна.</div>
                  </div>
                </div>

                <div v-else class="alert alert-success">Одоогоор энэ асуултанд хариулт оруулаагүй байна.</div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

     <div
      class="modal fade"
      id="qaModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="qaModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="qaModalLabel">Бүлэг нэмэх</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                  <input v-if="selectedCategory!=null" 
                  v-model.trim="selectedCategory.name"
                  class="form-control"
                  id="exampleInputEmail"
                  aria-describedby="emailHelp"
                  placeholder="Бүлгийн нэр"
                />  
              </div>

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button
              @click="changeCategoryName"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >Save</button> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import BarChart from "../BarChart.js";
import { stat } from "fs";
var colors = [
  "#00E396",
  "#FEB019",
  "#FF4560",
  "#775DD0",
  "#546E7A",
  "#26a69a",
  "#D10CE8"
];
export default {
  name: "DetailQuestions",
  components: {
    BarChart
  },
  data() {
    return {
      selectedCategory: null,
      categories: [],
      questions: [],
      content:null,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [
            {
              ticks: {
                userCallback: function(label, index, labels) {
                  if (typeof label === "string" && label.length > 10) {
                    return label.substring(0, 20) + " ...";
                  }
                  return label;
                }
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      statData: {
        chartOptions: {
          chart: {
            id: "basic-bar"
          },
          colors: colors,
          labels: {
            show: true,
            hideOverlappingLabels: false
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: true,
              endingShape: "rounded"
            }
          }
          // plotOptions: {
          //     bar: {
          //     horizontal: false,
          //     columnWidth: '55%',
          //     endingShape: 'rounded'
          //     },
          // },
        },
        series: [
          {
            name: "series-1",
            data: [
              {
                x: "Apple",
                y: 54
              },
              {
                x: "Orange",
                y: 66
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    
    _getQA() {
      fb.db
        .collection("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/questions").orderBy("createdAt","asc")
        .onSnapshot(querySnapshot => {
          this.questions = [];
          querySnapshot.forEach(doc => {
             let question=doc.data();
              question.id=doc.id;
              question.subquestions=[];

              doc.ref.collection("subquestions").get().then(subDocs=>{
                subDocs.forEach((subquestion, index)=> {
                    let object=subquestion.data();
                    object.id = subquestion.id;
                    object.answers=[];
   
                    if(object.answertype==true){
                      object.useranswers=[]
                      this._getQuestionAnswers(object, subquestion.ref);
                    }
                    else{
                      object.answers = [];
                      this._getAnswers(object, subquestion.ref);
                    }

                    question.subquestions.push(object);

                });
              });

              this.questions.push(question);
          });
        });
    },
    _getAnswers(question, ref) {
      if (question.answers == null || question.answers == undefined)
        question.answers = [];
      ref
        .collection("answers")
        .orderBy("votedCount", "desc")
        .onSnapshot(querySnapshot => {
          question.answers = [];
          let labels = [];
          let dataset = [
            {
              label: "A",
              backgroundColor: "#f87979",
              data: [],
              backgroundColor: []
            }
          ];
          let data = [];
          let index = 0;
          let answered = false;
          querySnapshot.forEach(doc => {
            let answer = doc.data();
            answer.id = doc.id;
            if (answer.votedCount != null && answer.votedCount > 0)
              answered = true;
            labels.push(answer.name);
            dataset[0].data.push(answer.votedCount);
            dataset[0].backgroundColor.push(
              index <= colors.length ? colors[index] : this.getRandomColor()
            );
            data.push({
              x: answer.name,
              y: answer.votedCount,
              color: this.getRandomColor()
            });

            question.answers.push(answer);
            index++;
          });
          if (answered == true) {
            question.statData = this.statData;
            question.datacollection = {
              labels: labels,
              datasets: dataset
            };
            // this.statData.chartOptions.xaxis.categories=labels
            question.statData.series = [
              {
                name: "санал",
                data: data
              }
            ];
          } else {
            question.datacollection = null;
            question.statData = null;
          }
        });
    },
    _getQuestionAnswers(question, ref){
      ref.collection("votedusers").get().then(querySnapshot=>{
        querySnapshot.forEach(doc => {
          let answer = doc.data();
          answer.id = doc.id;
          question.useranswers.push(answer);
        });
      });
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    editCategory(cat) {
      
      this.selectedCategory = Object.assign({}, cat);
      console.log(cat);
      console.log(this.selectedCategory);
      $("#qaModal").modal();
    },
    changeCategoryName(selectedCategory){

      fb.db.collection("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests").doc(this.selectedCategory.id).update(this.selectedCategory);
            
    },
    editQuestion(question, category) {

      if(category!=null){
        if(question.simple==true)
          this.$router.push({ name: "SimpleQuestionAdd", params: { questionId: question.id, categoryId:category.id, detailPath: "lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });
        else
          this.$router.push({ name: "DetailQuestionAdd", params: { questionId: question.id, categoryId:category.id, detailPath: "lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });
      }
      else{
        if(question.simple==true)
          this.$router.push({ name: "SimpleQuestionAdd", params: { questionId: question.id, categoryId:'new', detailPath: "lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });
        else
          this.$router.push({ name: "DetailQuestionAdd", params: { questionId: question.id, categoryId:'new', detailPath: "lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });
      }
    },
    
    deleteQuestion(question){
       var result = confirm("Та устгаxыг xүсэж байна уу? : "+ question.id + " " + question.category);
        if (result) {
            if(question!=null && question.category!=null && question.id!=null) {

              this.categories.forEach(cat =>{
                if(cat.id == question.category) {
                  
              fb.db.collection("asuulga").doc(this.qaId).collection("categories").doc(question.category).
              collection("questions").doc(question.id).delete()
                  cat.questions.splice(question);
                }
              })
            }
        }
    },
    deleteCategory(cat){
      var result = confirm("Та устгаxыг xүсэж байна уу? : "+ cat.id + " " + cat.name);
      if (result) {
        fb.db.collection("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests").doc(cat.id).delete()
        this.categories.splice(cat);
      }
    },
    addQuestion(cat, simple) {
      if(simple==true)
        this.$router.push({ name: "SimpleQuestionAdd", params: { questionId: "new", categoryId:cat, detailPath: "lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });
      else
         this.$router.push({ name: "DetailQuestionAdd", params: { questionId: "new", categoryId:cat, detailPath: "lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId} });

    },
    addBulkQuestion() {
      this.$router.push({ name: "QuestionAddBulk", params: { questionId: "new",} });
    },
    _setLabel(questionId, status, field, category) {
      var tmp = {};
      tmp[field] = status;
      if(category==null || (category!=null && category.id==null))
        fb.db
          .doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId)
          .collection("questions")
          .doc(questionId)
          .update(tmp);
      else{
        fb.db
          .doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId+'/tests/'+category.id)
          .collection("questions")
          .doc(questionId)
          .update(tmp);
      }
    },
    _setPublishedContent(status) {
      fb.db
        .doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId)
        .update({'published':status});
      this.content.published=status;
     
    },
    _getQuestionsOfCategory(cat, catRef){
      catRef
        .collection("questions").orderBy("createdAt","asc").onSnapshot(querySnapshot =>{
          cat.questions=[]
          querySnapshot.forEach(doc => {

              let question=doc.data();
              question.id=doc.id;
              question.subquestions=[];

              doc.ref.collection("subquestions").get().then(subDocs=>{
                subDocs.forEach((subquestion, index)=> {
                    let object=subquestion.data();
                    object.id = subquestion.id;
                    object.answers=[];
   
                    if(object.answertype==true){
                      object.useranswers=[]
                      this._getQuestionAnswers(object, subquestion.ref);
                    }
                    else{
                      object.answers = [];
                      this._getAnswers(object, subquestion.ref);
                    }

                    question.subquestions.push(object);

                });

              cat.questions.push(question);
            })
          });
        });
    },
    _findCategories(){


      fb.db
        .collection("lessons/" + this.lessonId + "/topics/"+this.topicId+"/details/"+this.detailId+"/tests").orderBy("createdAt","asc")
        .onSnapshot(querySnapshot => {
          this.categories = [];
          querySnapshot.forEach(doc => {
            let cat = doc.data();
            cat.id = doc.id;
            cat.questions=[]
            this._getQuestionsOfCategory(cat, doc.ref)
            this.categories.push(cat);
          });
        });

      this.categories.push({name:'--no group--', id:'null'});

    },
    _addCategory(){
      if(this.categories==null)
        this.categories=[];
      if(this.categories.length==0){
        var newCategory={
          name:'Бүлэг-'+ this.categories.length,
          createdAt: new Date()
        }
        fb.db.collection("lessons")
              .doc(this.lessonId)
              .collection("topics").doc(this.topicId).collection("details").doc(this.detailId).collection('tests').doc().set(newCategory)
      }
    },
    getContent(){
      fb.db.doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.detailId).get().then(detailDoc=>{
        if(detailDoc.exists){
          let detail=detailDoc.data();
          detail.id=detailDoc.id;
          this.content=detail;
        }
      });
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },

  props: {
    lessonId: {
      required: true
    },
    topicId: {
      required: true
    },
    detailId: {
      required: true
    }
  },
  created() {
    if(this.lessonId!=null && this.lessonId!='' && this.topicId!=null && this.topicId!='' && this.detailId!=null && this.detailId!='' ){
      this._findCategories();
      this.getContent();
    }
    
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    }
  }
};
</script>

<style>
  .panel-body >.list-group{
      max-height: 350px;
      margin-bottom: 10px;
      overflow-y:auto;
      -webkit-overflow-scrolling: touch;
  }
</style>